import { render, staticRenderFns } from "./FensitoutiaoPage.vue?vue&type=template&id=348240e9&scoped=true&"
import script from "./FensitoutiaoPage.vue?vue&type=script&lang=js&"
export * from "./FensitoutiaoPage.vue?vue&type=script&lang=js&"
import style0 from "./FensitoutiaoPage.vue?vue&type=style&index=0&id=348240e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348240e9",
  null
  
)

export default component.exports